module.exports = __webpack_public_path__ + "static/Neue-Haas-Grotesk-Display-65-442bff58a68d0ec671902a3d06866ae0.woff";